import * as St from './InvoiceTable.styles';

import { useOrderInvoice } from '~/UI/pages/OrderSummaryPage/hooks';

export interface InvoiceTableProps {
  maxHeight?: string;
}

const InvoiceTable = ({ maxHeight = '580rem' }: InvoiceTableProps) => {
  const { items } = useOrderInvoice();

  return (
    <St.Container style={{ maxHeight }}>
      {items.map((item, index) => (
        <St.Row key={index}>
          <St.Col>
            <span>{item.label}</span>
          </St.Col>
          <St.Col
            $align="right"
            $showWarning={item.showLineItemQuantityWarning}
          >
            {item.measure}
          </St.Col>
          <St.Col $align="right">{item.price}</St.Col>
          {item.notes?.map((note, noteIndex) => (
            <St.Note key={noteIndex}>{note}</St.Note>
          ))}
        </St.Row>
      ))}
    </St.Container>
  );
};

export default InvoiceTable;
